
import { Component, Vue, Prop, VModel } from "vue-property-decorator";
import { exportFlowFile } from "@pazion/pazion-core/src/services/base-service";

@Component
export default class EntityToCsvExportDialog extends Vue {
  @VModel({
    default: false,
  })
  dialog: boolean;

  @Prop({default: 'order'})  exportTemplate!: string;

  dateFrom: string | null = null;
  dateTo: string | null = new Date().toISOString().split("T")[0]; // Standaard vandaag

  get canExport(): boolean {
    return (
        true === this.isValidDate(this.dateFrom) &&
        true === this.isValidDate(this.dateTo) &&
        new Date(this.dateFrom!) <= new Date(this.dateTo!)
    );
  }

  closeDialog() {
    this.dialog = false;
  }

  isValidDateOrNull(date: string | null): boolean {
    if (!date) return true;
    const parsedDate = Date.parse(date);
    if(isNaN(parsedDate)){
      return 'Invalid date';
    }
    return true;
  }
  isValidDate(date: string | null): boolean|string {
    if (!date) return 'Ongeldige datum';
    const parsedDate = Date.parse(date);
    if(isNaN(parsedDate)){
        return 'Ongeldige datum';
    }
    return true;
  }

  async makeExport() {
    if (!this.canExport) return;

    const filter = {
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
    };

    try {
      const rsp = await exportFlowFile(this.exportTemplate, filter);
      await this.processResponse(rsp.data);
      this.closeDialog();
    } catch (error) {
      console.error("Error during export:", error);
    }
  }

  async processResponse(response: any): Promise<boolean> {
    try {
      if (!response.success) {
        console.error("Export failed:", response);
        return false;
      }

      const csvContent = response.file;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "survey_export.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (error) {
      console.error("Error processing export response:", error);
      return false;
    }
  }
}
